"use client";

import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Uber() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="über" ref={ref} className="bg-card py-20 md:py-32 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8 md:gap-12 lg:gap-16">
          {}
          <div className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-default font-semibold text-foreground leading-relaxed">
                Über Gedankengänge
              </h2>

              <p className="text-lg md:text-xl font-default text-foreground leading-relaxed font-light">
                Willkommen bei Gedankengänge. Hier teile ich persönliche Essays und
                Reflexionen zu philosophischen und gesellschaftsrelevanten Themen. Jeder
                Beitrag ist ein Gedankenstrom – nicht immer linear, aber immer ehrlich.
              </p>

              <p className="text-base md:text-lg font-default text-foreground leading-relaxed">
                Der Blog entstand aus dem Wunsch, die vielen Gedanken, die sich täglich
                formen und entwickeln, zu dokumentieren und zu teilen. In einer Zeit der
                ständigen Reizüberflutung möchte ich einen Raum schaffen, in dem Denken
                Zeit und Ruhe hat – leere Räume für Reflexion.
              </p>

              <p className="text-base md:text-lg font-default text-foreground leading-relaxed">
                Die Beiträge hier sind persönlich und subjektiv. Sie entstehen aus
                Neugier, Beobachtung und dem Versuch, die Welt und unsere Rolle darin
                besser zu verstehen. Es geht nicht um absolute Wahrheiten, sondern um
                den Prozess des Denkens selbst.
              </p>
            </div>
          </div>

          {}
          <div className="hidden md:flex items-start justify-center pt-8">
            <Separator orientation="vertical" className="h-64 bg-accent/40" decorative />
          </div>
        </div>
      </div>
    </section>;
}